import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeAuthDialog } from "../../slices/authDialog";
import { Typography, Box } from "@mui/material";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import WarningIcon from "../../assets/icons/gradient/warning.svg";
import InlineSVG from "../inline-svg/inline-svg-component";
import axiosInstance from "../../api/axiosConfig";

const AuthDialog = () => {
  const dispatch = useDispatch();
  const { open, message } = useSelector((state) => state.authDialog);

  const [countdown, setCountdown] = useState(5);

  const handleClose = async () => {
    try {
      await axiosInstance.post("/auth/logout");
      localStorage.clear();
      dispatch(closeAuthDialog());
      window.location.href = "/fibre/prepaid/?loggedOut=true";
    } catch (e) {
      localStorage.clear();
      dispatch(closeAuthDialog());
      window.location.href = "/fibre/prepaid/?loggedOut=true";
    }
  };

  useEffect(() => {
    let timer;
    if (open) {
      setCountdown(5);

      // Start the countdown timer
      timer = setInterval(() => {
        setCountdown((prevCountdown) => {
          if (prevCountdown <= 1) {
            clearInterval(timer);
            handleClose(); // Redirect when countdown reaches zero
            return 0;
          }
          return prevCountdown - 1;
        });
      }, 1000);
    }

    // Cleanup the timer when the dialog is closed or unmounted
    return () => {
      if (timer) clearInterval(timer);
    };
  }, [open]); // Only re-run the effect if 'open' changes

  return (
    <Dialog
      open={open}
      onClose={null} // Disable closing the dialog by clicking outside
      aria-labelledby="auth-dialog-title"
      aria-describedby="auth-dialog-description"
      ModalProps={{
        disableEscapeKeyDown: true,
      }}
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)",
            WebkitBackdropFilter: "blur(5px)",
          },
        },
      }}
    >
      <DialogTitle id="auth-dialog-title" sx={{ textAlign: "center" }}>
        <InlineSVG
          src={WarningIcon}
          width={80}
          height={80}
          ariaHidden
          className="mb-4"
        />
        Your Session Has Expired
      </DialogTitle>
      <DialogContent>
        <Box
          sx={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "16px",
          }}
        >
          <Typography variant="body1" sx={{ mb: 3 }}>
            {message || "Your session has expired. Please sign in again."}
          </Typography>
          <Typography
            variant="h2"
            component="div"
            sx={{ fontWeight: "bold", fontSize: "4rem" }}
          >
            {countdown}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AuthDialog;
